<vpfa-field-validation-container
  [isText]="isText"
  [isNumber]="isNumber"
  [isCurrency]="isCurrency"
  [heightCompensationPx]="heightCompensationPx"
  [errorMessages]="errorMessages"
  [errorMsgVertPosition]="errorMsgVertPosition"
  [displayErrors]="displayErrors && (control?.dirty || (considerAlsoTouchedControlsAsInvalid && control?.touched))"
  [isInvalid]="(isInvalid$ | async) && (control?.dirty || (considerAlsoTouchedControlsAsInvalid && control?.touched))"
  [validationErrors]="control?.errors"
  [errorPopoverPlacement]="errorPopoverPlacement"
  [ngClass]="{ 'max-width': maxWidth }"
>
  <nz-form-control>
    <ng-content></ng-content>
  </nz-form-control>
</vpfa-field-validation-container>
